import React, { Component, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Label } from "reactstrap";
import request, { NodeURL } from "../api/api";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import {
	AvFeedback,
	AvForm,
	AvGroup,
	AvInput,
} from "availity-reactstrap-validation";

import IntlTelInput from "react-intl-tel-input";
import { libphonenumber } from "react-intl-tel-input/dist/libphonenumber.js";
import "react-intl-tel-input/dist/main.css";

import Select from "react-select";
import { validatePassword, confirmPassword } from '../components/common/passwordValidation';
class RegisterCandidate extends Component {
	state = {
		username: "",
		password: "",
		confirm_password: "",
		name: "",
		email: "",
		role: "",
		code: "",
		number: "",
		dailcountry: "gb",
		address: "",
		line1: "",
		line2: "",
		city: "",
		state: "",
		country: "",
		zipcode: "",
		formatted_address: "",
		lat: "",
		lon: "",
		avatar: "",
		phoneerror: false,
		phoneNumberEmpty: false,
		job_typeEmpty: false,
		locationsEmpty: false,
		agencylist: [],
		phonestatus: "",
		timelist: [],
		agency: "",
		joblist: [],
		subdomain: "",
		locationlist: [],
		employee_rate: "",
		status: 1,
		isverified: 1,
		avatarfile: "",
		propreview: null,
		recapcha: "",
		logo_loder: false,
		agency_company_name: "",
		filterLocationList: [],
		filterLocation: "",
		locations: [],
		job_type: [],
		filterjobroleList: [],
		filterjobrole: "",
		templateid:"",
		errors: {
			newpassword: '',
			confirmnewpassword: '',
		},
		isPreSelectedJobType: false,
		isPreSelectedLocation: false,
		isPreSelectedIndustryType: false,
		industryType: [],
	};

	getJobTypeLocation = () => {
		this.setState({ logo_loder: true });
		let { agency = '' , templateid = '' } = this.state;
		request({
			url: `/site/get/jobtypes/locations?addedId=${agency}&templateId=${templateid}`,
			method: 'GET',
		}).then(res => {
			if (res && +res.status === 1) {
				this.setState({
					filterjobroleList: res.response && res.response.jobtypes && Array.isArray(res.response.jobtypes) && res.response.jobtypes.length > 0 ? [...res.response.jobtypes].map((item) => { let obj = {}; obj['value'] = item._id; obj['label'] = item.name; return obj; }) : [],
					filterLocationList: res.response && res.response.locations && Array.isArray(res.response.locations) && res.response.locations.length > 0 ? [...res.response.locations].map((item) => { let obj = {}; obj['value'] = item._id; obj['label'] = item.name; return obj; }) : []
				});
			}
		}).catch(err => {
			console.log("err in /site/get/jobtypes/locations?addedId", err);
		}).finally(() => {
			this.setState({ logo_loder: false });
		});
	};

	getRegisterTokenData = async() =>{
		let register_token = (window.location.hash && window.location.hash.substring(1)) || ''
		if(register_token){
			request({
				url: "/site/candidate/register",
				method: "POST",
				data: { register_token },
			}).then((res ={}) => {
				if (res.status === 1) {
					let reg = res.response || {},
						phone = res.response.phone || {};

					this.setState({
						email:reg.email || "",
						name:reg.name || "",
						surname:reg.surname || "",
						...phone,
						templateid:reg.templateid
					})
					if(reg.userstatus === 2){
						toast.error("Email already exists")
					}
				} else if (res.status === 0) {
					// window.location = "/";
				}
				return res;
			});
		} else{
			// window.location = '/'
		}

	}

	componentDidMount() {
		const subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : false;
		if (subdomain) {
			request({
				url: "/site/checkdomain",
				method: "POST",
				data: { subdomain },
			}).then((res) => {
				let agency = res.agency && res.agency.length > 0 ? res.agency : ''
				console.log({res});
				if (res.status === 1) {
					this.setState({ subdomain: subdomain, agency},() => {
						// this.getJobTypeLocation()
					});
				} else if (res.status === 0) {
					window.location = "/";
				}
			});
		} else {
			//window.location = "/";
		}
		/*this one for job ads from site*/
		const params = new URLSearchParams(window.location.search);
		let job_type = [];
		let locations = [];
		let industryType = [];
		const jobTypeParam = params.get('job_type');
		const locationsParam = params.get('locations');
		const industryParam = params.get('industryType');

		job_type = jobTypeParam ? JSON.parse(decodeURIComponent(jobTypeParam)) : [];
		locations = locationsParam ? JSON.parse(decodeURIComponent(locationsParam)) : [];
		industryType = industryParam ? JSON.parse(decodeURIComponent(industryParam)) : [];

		if (job_type.length > 0) {
			this.setState({ job_type, isPreSelectedJobType: true });
		}
		if (locations.length > 0) {
			this.setState({ locations, isPreSelectedLocation: true });
		}
		if (industryType.length > 0) {
			this.setState({ industryType, isPreSelectedIndustryType: true });
		}

		this.getRegisterTokenData()
			.finally(()=>{
				request({
					url: "/site/agencies",
					method: "POST",
				}).then((res) => {
					this.setState({ logo_loder: true });
					const filteredlist = res.response.result && res.response.result.filter((list) => list.domain.toString() === subdomain.toString());
					// const filterjobroleList = filteredlist[0].jobtypes.map((item) => {
					// 	return {
					// 		value: item._id,
					// 		label: item.name,
					// 	};
					// });
					// this.setState({
					// 	filterjobroleList,
					// });
					// const filterLocationList = filteredlist[0].locations.map((item) => {
					// 	return {
					// 		value: item._id,
					// 		label: item.name,
					// 	};
					// });
					// this.setState({
					// 	filterLocationList,
					// });
					this.setState(
						{
							agency: filteredlist && filteredlist.length > 0 ? filteredlist[0]._id: '',
							agency_company_name: filteredlist[0] && filteredlist[0].company_name,
							agency_company_logo: filteredlist[0] && filteredlist[0].company_logo,
						},
						() => {
							this.getJobTypeLocation();
							this.setState({ logo_loder: false });
						}
					);
					this.setState({ agencylist: res.response.result });
				}).finally(() => {
					this.setState({ logo_loder: false });
				});
			});

		// request({
		// 	url: "/site/settings",
		// 	method: "POST",
		// }).then((res) => {
		// 	if (res.status === 1) {
		// 		this.setState({ logo_loder: true });
		// 		// this.setState(
		// 		// 	{
		// 		// 		sitesettings_logo: res.response.settings.logo || {},
		// 		// 	},
		// 		// 	() => {
		// 		// 		this.setState({ logo_loder: false });
		// 		// 	}
		// 		// );
		// 	} else if (res.status === 0) {
		// 		toast.error(res.response);
		// 	}
		// }).catch((err) => {
		// 	toast.error(err);
		// }).finally(() => {
		// 	this.setState({ logo_loder: false });
		// });
	}

	onChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	handleBlur = e => {
		const { name, value } = e.target;
		let errorMessage = '';
  
		if (name === 'password') {
		   errorMessage = validatePassword(value);
  
		   if (errorMessage) {
			  this.setState({ errors: { ...this.state.errors, newpassword: errorMessage } });
		   } else {
			  this.setState({ errors: { ...this.state.errors, newpassword: '' } });
		   }
		}
		if (name === 'confirm_password') {
		  let newpassword = this.state.password
		   errorMessage = confirmPassword(newpassword, value);
  
		   if (errorMessage) {
			  this.setState({ errors: { ...this.state.errors, confirmnewpassword: errorMessage } });
		   } else {
			  this.setState({ errors: { ...this.state.errors, confirmnewpassword: '' } });
		   }
		}
	 };

	handler = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				phoneerror: false,
			});
		} else {
			this.setState({
				phoneerror: true,
			});
		}
		this.setState({
			number: value,
			code: countryData.dialCode,
			dailcountry: countryData.iso2,
		});
	};

	jobtypeselect = (value) => {
		if (value && Array.isArray(value) && value.length > 0) {
			this.setState({ job_type: value });
		} else {
			this.setState({ job_type: [] });
		}
	};

	locationsselect = (value) => {
		if (value && Array.isArray(value) && value.length > 0) {
			this.setState({ locations: value });
		} else {
			this.setState({ locations: [] });
		}
	};

	OnFormSubmit = (e, values) => {
		const { number, job_type, locations } = this.state;

		if (number === "" || job_type.length === 0 || locations.length === 0) {
			this.setState({
				phoneNumberEmpty: true,
			});
		}
		// else if (job_type.length === 0) {
		//   this.setState({
		//     job_typeEmpty: true,
		//   });
		// } else if (locations.length === 0) {
		//   this.setState({
		//     locationsEmpty: true,
		//   });
		// } 

		else {
			const data = new FormData();
			data.append("subdomain", this.state.subdomain);
			data.append("username", this.state.username);
			data.append("password", this.state.password);
			data.append("confirm_password", this.state.confirm_password);
			data.append("name", this.state.name);
			data.append("surname", this.state.surname);
			data.append("email", this.state.email);
			data.append("job_type", JSON.stringify(this.state.job_type));
			data.append("locations", JSON.stringify(this.state.locations));
			data.append("employee_rate", this.state.employee_rate);
			data.append("agency", this.state.agency);
			data.append("avatar", this.state.avatar);
			data.append("phone[code]", this.state.code);
			data.append("phone[number]", this.state.number);
			data.append("phone[dailcountry]", this.state.dailcountry);
			data.append("address[line1]", this.state.line1);
			data.append("address[line2]", this.state.line2);
			data.append("address[city]", this.state.city);
			data.append("address[state]", this.state.state);
			data.append("address[country]", this.state.country);
			data.append("address[zipcode]", this.state.zipcode);
			data.append("address[formatted_address]", this.state.formatted_address);
			data.append("address[lat]", this.state.lat);
			data.append("address[lon]", this.state.lon);
			data.append("status", this.state.status);
			data.append("isverified", this.state.isverified);
			data.append("port", window.location.port);
			data.append("hostname", window.location.hostname);
			data.append("protocol", window.location.protocol);
			data.append("templateId" ,(this.state.templateid || ""))
			data.append("isPreSelectedJobType" ,(this.state.isPreSelectedJobType))
			data.append("isPreSelectedLocation" ,(this.state.isPreSelectedLocation))
			data.append("industryType", JSON.stringify(this.state.industryType));
			request({
				url: "/register/employee",
				method: "POST",
				data: data,
			})
				.then((res) => {
					if (res.status === 1) {
						this.setState({ number: "", address: "" });
						toast.success("Registered successfully");
						this.props.history.push({ pathname: "/login", state: true });
					} else if (res.status === 0) {
						toast.error(res.response);
					}
				})
				.catch((error) => {
					toast.success(error);
				});
		}
	};

	render() {
		const { logo_loder } = this.state;
		const logourl = this.state.agency_company_logo
			? this.state.agency_company_logo
			: this.state.sitesettings_logo;
		return (
			<Fragment>
				<ToastContainer position="top-right" autoClose={2500} closeOnClick />
				<section className="section login-spaces regi-spaces formcont-shadow">
					<div className="container">
						<div className="row form">
							<div className="agency-boxes login-cont">
								<div className="box-width">
									<div className="employee-forms">
										<div className="new-agency-body">
											<div className="new-agency-login">
												{logo_loder ? (
													<div className="home-loader">
														<i className="fa fa-spinner fa-spin fa-5x" />{" "}
													</div>
												) : (
													<img src={`${NodeURL}/${logourl}`} alt="" />
												)}
											</div>
											<h4>
												{this.state.agency_company_name}
											</h4>
											<h6>
												Complete the form below to register
											</h6>
											<AvForm
												className="theme-form"
												onValidSubmit={this.OnFormSubmit}
												// autoComplete="off"
											>

												<h5 className="head-forms"> Your Details </h5>
												<AvGroup className="form-group">
													<Label className="col-form-label">First Name <span style={{ color: 'red' }} >*</span>  </Label>
													<AvInput
														className="form-control"
														type="text"
														name="name"
														placeholder="Your First Name.."
														onChange={this.onChange}
														value={this.state.name}
														required
													/>
													<AvFeedback>First Name is required!</AvFeedback>
												</AvGroup>
												<AvGroup className="form-group">
													<Label className="col-form-label">Last Name <span style={{ color: 'red' }} >*</span> </Label>
													<AvInput
														className="form-control"
														type="text"
														name="surname"
														placeholder="Your Last Name.."
														onChange={this.onChange}
														value={this.state.surname}
														required
													/>
													<AvFeedback>Last Name is required!</AvFeedback>
												</AvGroup>
												<AvGroup className="form-group">
													<Label className="col-form-label">Email Address <span style={{ color: 'red' }} >*</span> </Label>
													<AvInput
														className="form-control"
														name="email"
														type="email"
														placeholder="Your Email Address.."
														onChange={this.onChange}
														value={this.state.email}
														required
														// disabled
													/>
													<AvFeedback>Email Address is required!</AvFeedback>
												</AvGroup>

												<AvGroup className="form-group">
													<Label className="col-form-label">Phone Number <span style={{ color: 'red' }} >*</span> </Label>
													<IntlTelInput
														placeholder=""
														style={{ width: "100%" }}
														defaultCountry={this.state.dailcountry}
														utilsScript={libphonenumber}
														css={
															this.state.phoneerror
																? [
																	"intl-tel-input",
																	"form-control",
																	"error-color",
																]
																: ["intl-tel-input", "form-control"]
														}
														onPhoneNumberChange={this.handler}
														value={this.state.number}
														required
													/>
													{this.state.phoneNumberEmpty &&
														this.state.number === "" ? (
														<div style={{ color: "#dc3545" }}>
															Phone Number is required!
														</div>
													) : null}
													{this.state.phoneerror ? (
														<div style={{ color: "#dc3545" }}>
															Enter Valid Phone Number!
														</div>
													) : null}
												</AvGroup>

												<h5 className="head-forms">Work Details </h5>

												<AvGroup className="form-group">
													<Label className="col-form-label"> Role(s) Applying For  <span style={{ color: 'red' }} >*</span> </Label>

													<Select
														name="job_type"
														value={this.state.job_type}
														options={ this.state.isPreSelectedJobType
															? this.state.job_type
															:this.state.filterjobroleList
														}
														onChange={this.state.isPreSelectedJobType
															? null 
															: this.jobtypeselect
														}
														isMulti
														isDisabled={this.state.isPreSelectedJobType}
														required={true}
													/>
													{this.state.phoneNumberEmpty &&
														this.state.job_type.length === 0 ? (
														<div style={{ color: "#dc3545" }}>
															Job Role is required!
														</div>
													) : null}
												</AvGroup>

												<AvGroup className="form-group">
													<Label className="col-form-label"> Select Work Area(s)  <span style={{ color: 'red' }} >*</span> </Label>
													
													<Select
														name="client-select"
														value={this.state.locations}
														options={this.state.isPreSelectedLocation
															? this.state.locations
															: this.state.filterLocationList
														}
														onChange={this.state.isPreSelectedLocation
															? null 
															: this.locationsselect
														}
														isDisabled={this.state.isPreSelectedLocation}
														isClearable={true}
														isMulti
													/>
													{this.state.phoneNumberEmpty &&
														this.state.locations.length === 0 ? (
														<div style={{ color: "#dc3545" }}>
															Location is required!
														</div>
													) : null}
												</AvGroup>
												{
												this.state.isPreSelectedIndustryType && <AvGroup className="form-group">
													<Label className="col-form-label"> Select Industry Type  <span style={{ color: 'red' }} >*</span> </Label>
													
													<Select
														name="client-select"
														value={this.state.industryType}
														options={this.state.industryType}
														onChange={null}
														isDisabled={this.state.isPreSelectedIndustryType}
														isClearable={true}
														isMulti
													/>
													{this.state.phoneNumberEmpty &&
														this.state.locations.length === 0 ? (
														<div style={{ color: "#dc3545" }}>
															Location is required!
														</div>
													) : null}
												</AvGroup>
												}	
												<h5 className="head-forms"> Account Details </h5>

												<AvGroup className="form-group">
													<Label className="col-form-label">Choose a Username <span style={{ color: 'red' }} >*</span> </Label>
													<AvInput
														className="form-control"
														type="text"
														name="username"
														placeholder="Memorable Username.."
														onChange={this.onChange}
														value={this.state.username}
														required
													/>
													<AvFeedback>Username is required!</AvFeedback>
												</AvGroup>




												<AvGroup className="form-group">
													<Label className="col-form-label">Choose Password <span style={{ color: 'red' }} >*</span> </Label>
													<AvInput
														className="form-control"
														type="password"
														name="password"
														placeholder="Choose Password.."
														onChange={this.onChange}
														onBlur={this.handleBlur}
														value={this.state.password}
														required
														autoComplete="off"
														validate={{
															pattern: {
															   value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/
															},
														 }}
													/>
													  <AvFeedback>{this.state.errors.newpassword}</AvFeedback>
												</AvGroup>
												<AvGroup className="form-group">
													<Label className="col-form-label">
														Confirm Password <span style={{ color: 'red' }} >*</span>
													</Label>
													<AvInput
														type="password"
														className="form-control"
														name="confirm_password"
														placeholder="Choose Confirm Password.."
														onChange={this.onChange}
														onBlur={this.handleBlur}
														value={this.state.confirm_password}
														required
														validate={{ match: { value: "password" } }}
													/>
													 <AvFeedback>{this.state.errors.confirmnewpassword}</AvFeedback>
												</AvGroup>
												<div className="mid-btns">

													<button className="login-btns" type="submit">
														Register
															</button>

													<p className="reg-again text-center">
														<span className="page-login">  Are you already a user? </span>

														<Link
															to="/login"
														>
															Login
																</Link>
													</p>

												</div>
											</AvForm>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>


				{/* <div className="page-wrapper">
					<div className="container-fluid">
						
						<div className="authentication-main">
							<div className="row">
								<div className="col-sm-12 p-0">
									<div className="auth-innerright">
										<div className="authentication-box">
											<div className="text-center new-agency-login">
												
											</div>
											<div className="card mt-4 p-4">
												
												
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					
					</div>
				</div> */}
			</Fragment>
		);
	}
}
export default withRouter(RegisterCandidate);
